import { render, staticRenderFns } from "./MainSlider.vue?vue&type=template&id=7ecf7c61&scoped=true&"
import script from "./MainSlider.vue?vue&type=script&lang=js&"
export * from "./MainSlider.vue?vue&type=script&lang=js&"
import style0 from "./MainSlider.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MainSlider.vue?vue&type=style&index=1&id=7ecf7c61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecf7c61",
  null
  
)

export default component.exports